import { Icon } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useField } from 'react-final-form';
import { Level3Section } from '../Level3Section';
import { Level1Labels } from '../config';
import { useCameraViewContext } from '../CameraView/context';
import { SubmitButton } from './components/SubmitButton';
import { AllPhotosSection } from '../AllPhotosSection';
import { AllDamagedPhotos } from '../DamageSection';
import { InspectorComments } from '../InspectorComments';
import { Wrapper, HeaderRow, Title, StyledDialog, QuestionsWrapper, ContentWrapper } from './components/ui';
import { isNotesAlwaysOpened } from '../utils';

export const InFormQuestionsDialog = () => {
  const { confirmDialogOpened, closeConfirmDialog } = useCameraViewContext();

  const close = () => {
    closeConfirmDialog();
  };

  return (
    <StyledDialog
      onBackdropClick={close}
      open={confirmDialogOpened}
      isFullScreenMode={false}
      classes={{ paperScrollPaper: 'vehicle-questions' }}
    >
      {confirmDialogOpened && <VehicleQuestionsDialogContent close={close} />}
    </StyledDialog>
  );
};


const VehicleQuestionsDialogContent = ({ close }: { close: () => void }) => {
  const { level1SectionId } = useCameraViewContext();

  const {
    input: { value: formValues }
  } = useField(`${level1SectionId}.subsections`);

  if (level1SectionId?.startsWith('exterior')) {
    return <ExteriorDialogContent close={close} />;
  }

  return (
    <Wrapper>
      <HeaderRow>
        <Title>{Level1Labels[level1SectionId!]}</Title>
        <Icon onClick={close}>
          <Close />
        </Icon>
      </HeaderRow>
      <ContentWrapper>
        <QuestionsWrapper>
          {level1SectionId !== 'drive_cycles' && <AllPhotosSection collapsed sectionId={level1SectionId!} />}
          {Object.keys(formValues).map(key => (
            <Level3Section forceOpen={isNotesAlwaysOpened(key)} key={key} sectionId={`${level1SectionId}.subsections.${key}`} />
          ))}
          {level1SectionId === 'drive_cycles' && <InspectorComments theme="grey" />}
        </QuestionsWrapper>

        <SubmitButton />
      </ContentWrapper>
    </Wrapper>
  );
};

const ExteriorDialogContent = ({ close }: { close: () => void }) => {
  const {
    input: { value: tires }
  } = useField(`exterior.subsections.tires`);
  // const {
  //   input: { value: fitFinishFrame }
  // } = useField(`exterior.subsections.fit_finish_frame`);
  const {
    input: { value: exterior }
  } = useField(`exterior.subsections.exterior`);
  return (
    <Wrapper>
      <HeaderRow>
        <Title>{'Exterior'}</Title>
        <Icon onClick={close}>
          <Close />
        </Icon>
      </HeaderRow>
      <ContentWrapper>
        <QuestionsWrapper>
          <AllPhotosSection collapsed sectionId={`exterior.subsections.tires`} />
          {/* <AllPhotosSection collapsed sectionId={`exterior.subsections.fit_finish_frame`} /> */}
          <AllPhotosSection collapsed sectionId={`exterior.subsections.exterior`} />
          <AllDamagedPhotos theme="grey" collapsed />
          {Object.keys(tires.subsections).map((key, i) => (
            <Level3Section key={key} index={i} sectionId={`exterior.subsections.tires.subsections.${key}`} />
          ))}
          {/* {Object.keys(fitFinishFrame.subsections).map(key => (
            <Level3Section key={key} sectionId={`exterior.subsections.fit_finish_frame.subsections.${key}`} />
          ))} */}
          {Object.keys(exterior.subsections).map(key => (
            <Level3Section
              key={key}
              forceOpen={key === 'exterior_paint'}
              sectionId={`exterior.subsections.exterior.subsections.${key}`}
            />
          ))}
        </QuestionsWrapper>

        <SubmitButton />
      </ContentWrapper>
    </Wrapper>
  );
};
